import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { useBenefits } from '../BenefitsProvider'
import { Button } from '~/lib/ui/button'
import { InlineWidget } from 'react-calendly'
import {
  OrientationCallForm,
  LinkedInReviewForm,
  CallForm,
  ExecutiveBioForm,
  RecruiterTargetingForm,
  TargetCompanyResearchForm,
} from './RequestForms'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/lib/ui/select'
import ResumeReviewForm from './ResumeReviewForm'
import UploadNewResume from './UploadNewResume'

const ScheduleInner = ({ current_user, services, coach }) => {
  const { page, serviceRequestType } = useBenefits()

  const thirtyMinTypes = [
    'ServiceRequest::NetworkingStrategy',
    'ResumeRevision::CandidateRevision',
    'ServiceRequest::ExecutiveBio',
    'ServiceRequest::RecruiterTargeting',
    'ServiceRequest::BoardSearch',
  ]

  const meetingLeadTimes = {
    'ServiceRequest::MockInterview': 2,
    'ServiceRequest::BoardSearch': 3,
    'ServiceRequest::ExecutiveBio': 2,
    'ServiceRequest::CareerPivotPlanning': 2,
  }

  const meetingDuration = thirtyMinTypes.includes(serviceRequestType) ? 30 : 50
  const meetingLeadTime = meetingLeadTimes[serviceRequestType] || ''

  return (
    <div className="schedule-dialog">
      {page === 0 && <PageZero services={services} />}
      {page === 1 && <PageOne />}
      {page === 2 && (
        <div className="flex flex-col gap-6">
          <InlineWidget
            url={`${coach.calendly_link}/${meetingDuration}min${meetingLeadTime}`}
            prefill={{
              name: current_user.candidate_name,
              email: current_user.candidate_email,
            }}
          />
        </div>
      )}
    </div>
  )
}

const PageZero = ({ services }) => {
  const { t } = useTranslation('schedule_modal')
  const { serviceRequestType, setServiceRequestType, onScheduleClick, select } =
    useBenefits()

  const cardTitle = services.find(
    (service) => service.requestType === serviceRequestType,
  )?.title

  const handleValueChange = (e) => {
    setServiceRequestType(e)
  }
  const handleNextClick = () => {
    onScheduleClick(serviceRequestType, cardTitle, true, 1)
  }
  return (
    <div className="flex flex-col gap-6">
      <div>{t('page_0_instructions')}</div>
      <Select
        onValueChange={(e) => handleValueChange(e)}
        value={serviceRequestType}
        className="w-full rounded-[20px] border border-[#D3D3D3] bg-[#F7FAFC] p-3 font-roboto text-base"
      >
        <SelectTrigger>
          <SelectValue placeholder="Select an option" />
        </SelectTrigger>
        <SelectContent>
          {services.map((service, idx) => (
            <SelectItem key={idx} value={service.requestType}>
              {service.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <div>
        <Button
          onClick={handleNextClick}
          variant={select ? 'default' : 'coachcta'}
          disabled={!serviceRequestType} // Disable the button if the message is empty
        >
          {t('next_button')}
        </Button>
      </div>
    </div>
  )
}

const PageOne = () => {
  const { serviceRequestType } = useBenefits()
  const { t } = useTranslation('schedule_modal')

  if (serviceRequestType === 'ServiceRequest::OrientationCall')
    return <OrientationCallForm />
  if (serviceRequestType === 'ServiceRequest::LinkedInReview')
    return <LinkedInReviewForm />
  if (
    serviceRequestType === 'ServiceRequest::ResumeReview' ||
    serviceRequestType === 'ResumeRevision::CandidateRevision'
  )
    return <ResumeReviewForm />
  if (serviceRequestType === 'UploadNewResume') return <UploadNewResume />
  if (serviceRequestType === 'ServiceRequest::ExecutiveBio')
    return <ExecutiveBioForm />
  if (serviceRequestType === 'ServiceRequest::RecruiterTargeting')
    return <RecruiterTargetingForm />
  if (serviceRequestType === 'ServiceRequest::TargetCompanyResearch')
    return <TargetCompanyResearchForm />
  if (serviceRequestType === 'ServiceRequest::BoardSearch')
    return <CallForm electronic={true} submitCta={t('submit_request')} />
  return <CallForm />
}

export default ScheduleInner
